import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=fdec6a5a&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"
import style1 from "./Stats.vue?vue&type=style&index=1&id=fdec6a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdec6a5a",
  null
  
)

export default component.exports